import React from 'react';
import '../style/alternate-footer.css';

const goToOld=(oldUrl)=>{
	window.location.replace(window.location.origin+oldUrl);
}

const Footer=()=>{
	const oldUrl="/projects.html"+window.location?.search;
	return(

	<footer className="container-fluid pt-3 pb-3 footer-tail">
		<div id="new-version" className="iamnothere" onClick={()=>{goToOld(oldUrl)}}></div>
		<div className="col-md-12 text-center">
			&copy; 2017-<span id="copyright-year"></span> Meterian Ltd - &nbsp;
			<a href="/terms.html" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> - &nbsp;
			<a href="/gdpr.html" target="_blank" rel="noopener noreferrer">Privacy Polcy</a> - &nbsp;
			<a href="mailto:support@meterian.io">Contact Us</a>
		</div>
	</footer>
	)
}
export default Footer;